import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { LibsModule } from 'src/app/libs/libs.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FeaturePagesRoutingModule } from './feature-pages-routing.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { SimulatorComponent } from './simulator/simulator.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { CustomLabelComponent } from './custom-label/custom-label.component';
import { LabelTemplateComponent } from '../libs/components/label-template/label-template.component';

@NgModule({
  declarations: [
    SimulatorComponent,
    InvoicesComponent,
    CustomLabelComponent,
    LabelTemplateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AntDModule,
    LibsModule,
    NgbModule,
    NgSelectModule,
    NgxDaterangepickerMd,
    NgbDropdownModule,
    FeaturePagesRoutingModule
  ],
  exports: [
    SimulatorComponent,
    InvoicesComponent,
    CustomLabelComponent,
    LabelTemplateComponent
  ]
})
export class FeaturePagesModule { }
